export default "__VITE_PUBLIC_ASSET__01ffa228__"